module.exports = __webpack_public_path__ + "static/img/App item-1.1b30570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item-1.png
// module id = FrzT
// module chunks = 12